import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";

import _  from 'underscore';
import "survey-react/survey.css";
 import "./testing.css"

class Test extends Component {


  constructor(props){
    super(props)
    this.state = {
     
     };
     
    
    }

  

    



  render() {
 console.log("jidgksblk===---->", this.props.data.type)
    
    return (
                <div className="Home"> 
                     <div className="columns">     
                          <div className="column">
                            <p className="bd-notification is-danger">
                           
                                    <div class="tooltip" data-direction="bottom">
                                        <div class="tooltip__initiator">
                                           {this.props.data.name}
                                        </div>
                                        <div class="tooltip__item">
                                             Name
                                        </div>
                                      
                                    </div>
                            </p>
                            <div className="columns is-mobile">
                              <div className="column is-half">
                                <p className="bd-notification is-danger">
                                    <div class="tooltip" data-direction="bottom">
                                      <div class="tooltip__initiator">
                                            {this.props.data.title}
                                      </div>
                                      <div class="tooltip__item">
                                        Title
                                      </div>
                                      
                                    </div>
                                
                                </p>
                              </div>
                              <div className="column">
                              <div class="tooltip" data-direction="bottom">
                                          <div class="tooltip__initiator">
                                          
                                          {this.props.data.placeholder}
                                          </div>
                                          <div class="tooltip__item">
                                              Placeholder
                                          </div>
                            
                                    </div>
                            
                                
                              </div>
                              <div className="column">
                                   <div class="tooltip" data-direction="bottom">
                                          <div class="tooltip__initiator">
                                           {
                                             this.props.data.inputType?
                                             (<p>{this.props.data.inputType}</p>)
                                             :
                                             (<p> {this.props.data.type}</p>)
                                           }
                                               
                                          </div>
                                          <div class="tooltip__item">                                               
                                                   <p>Input Type</p> 
                                          </div>
                                      
                                    </div>
                                
                              </div>
                              <div className="column">
                                <div class="tooltip" data-direction="bottom">
                                    <div class="tooltip__initiator">
                                        <p className="bd-notification is-danger testing-isRequired">
                                          {
                                            // this.props.isRequired
                                            this.props.data.isRequired?
                                              " True"
                                              :
                                              " False"
                                            } 
                                        </p>
                                    </div>
                                    <div class="tooltip__item">
                                      Is Required
                                    </div>                           
                                  </div>
                              </div>
                              <div className="column">
                                <p className="bd-notification is-danger">Auto</p>
                              </div>
                          </div>
                        </div>
                        <div>
                            <div className="nameofchan-body">
                                {/* <div class="tooltip">Hover over me
                                  <span class="tooltiptext">Tooltip text</span>
                                </div> */}
                                {/* <div class="tooltip" data-direction="bottom">
                                  <div class="tooltip__initiator">
                                   
                                  Auto
                                  </div>
                                  <div class="tooltip__item">
                                    Hello!
                                  </div>
                                  
                                </div> */}

                                {/* <div class="tooltip" data-direction="bottom">
                                  <div class="tooltip__initiator">
                                   
                                    <i class="fa fa-info-circle"></i>
                                  </div>
                                  <div class="tooltip__item">
                                    Hello! I'm a pure css tooltip
                                  </div>
                                  
                                </div> */}
                            </div>
                        </div>
                      </div>

                </div>
            )
        }
    }    
  export default  Test  ;      






// WEBPACK FOOTER //
// ./src/component/testing/test.js